/* import user from '../../assets/testimonial/appdt.webp'; */

const data = [
  {
    id: 0,
    profileImg: "aProfile.jpg",
    company: "Software Engineer Student",
    name: "Jonathan Mendoza",
    testimony: `I create websites with UI/UX user interface, I have years of experience creating scalable projects of all kinds that you can find in my GitHub profile: jonathan20dev`,
  },
];
export default data;
